export default __webpack_public_path__ + "static/lukasz-406f22b6775ae0e6556fa98aa5adcf60.jpg";